const pressLogos = [
  { src: '/images/press1.png', alt: 'Press 1' },
  // { src: '/images/press2.png', alt: 'Press 2' },
  // { src: '/images/press3.png', alt: 'Press 3' },
  { src: '/images/press4.png', alt: 'Press 4' },
  { src: '/images/press5.png', alt: 'Press 5' },
  { src: '/images/press6.png', alt: 'Press 6' },
  { src: '/images/press7.png', alt: 'Press 7' },
  { src: '/images/press8.png', alt: 'Press 8' },
  { src: '/images/press9.png', alt: 'Press 9' },
];

const PressAndMedia = () => {
  return (
    <section
      className="py-12 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1e0a3c 0%, #2d1b69 20%, #1a1a6e 40%, #1e3a8a 60%, #1e40af 80%, #2563eb 100%)'
      }}
    >
      <style>{`
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 28s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      {/* Title */}
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white tracking-wide">
          Partners
        </h2>
        <div className="w-16 h-1 bg-white/40 mx-auto mt-4 rounded-full"></div>
      </div>

      {/* Marquee */}
      <div className="overflow-hidden w-full">
        <div className="marquee-track">
          {[...pressLogos, ...pressLogos].map((logo, i) => (
            <div
              key={i}
              className="flex-shrink-0 mx-3"
              style={{
                backgroundColor: 'white',
                borderRadius: '10px',
                width: '180px',
                height: '90px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 16px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
              }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                style={{ maxWidth: '100%', maxHeight: '60px', objectFit: 'contain' }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PressAndMedia;